import { useState } from "react"

import { Box } from "@mui/material"

import ManFront from "./ManFront"
import ManBack from "./ManBack"
import RotateButton from "./RotateButton"
import WomanBack from "./WomanBack"
import WomanFront from "./WomanFront"
import BoyBack from "./BoyBack"
import BoyFront from "./BoyFront"
import GirlBack from "./GirlBack"
import GirlFront from "./GirlFront"

import useAppStore from "store/app"

const BodySelector = () => {
  const [switchModel, setSwitchModel] = useState(false)
  const { age, gender } = useAppStore((state) => state.anamnesis)

  const handleSwitch = () => {
    setSwitchModel(!switchModel)
  }

  const getFrame = () => {
    if (gender === "female" && age < 16) {
      return switchModel ? <GirlBack /> : <GirlFront />
    }

    if (gender === "male" && age < 16) {
      return switchModel ? <BoyBack /> : <BoyFront />
    }

    if (gender === "female" && age >= 16) {
      return switchModel ? <WomanBack /> : <WomanFront />
    }

    if (gender === "male" && age >= 16) {
      return switchModel ? <ManBack /> : <ManFront />
    }
  }

  return (
    <Box
      sx={{
        backgroundColor: "white",
        p: 5,
        borderRadius: "20px",
        border: "1px solid #D8DFEB",
      }}
    >
      {getFrame()}
      <RotateButton handleSwitch={handleSwitch} />
    </Box>
  )
}

export default BodySelector
